import React from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import cx from 'classnames';
import * as yup from 'yup';

import Campaign, { selectCampaign } from 'store/models/Campaign';
import Channel, { selectChannelsByAccount } from 'store/models/Channel';
import Link, { selectLink, selectLinkUrls } from 'store/models/Link';
import { selectCurrentAccountId } from 'store/AppState';


import Modal, { ModalVertical, ModalHeader, ModalSubtitle, ModalContent, ModalActions, ModalTitle } from 'components/Modal';
import Button, { ButtonList, SmallButton } from 'components/Button';
import Scrollbars from 'components/Scrollbars';
import ChannelCard from 'components/ChannelCard';
import CopyInput from 'components/forms/CopyInput';
import { CopyIcon, ExcelIcon } from 'components/Svg';
import _ from 'lodash';

// ======================
// STORE
// ====================== 
const actions = {
  fetchData: (campaignId, linkId) => dispatch => {
    dispatch(Campaign.actions.fetchCampaign(campaignId));
    dispatch(Link.actions.fetchLink(linkId));
    dispatch(Channel.actions.fetchChannels());
    dispatch(Link.actions.fetchLinkUrls(campaignId, linkId));
  }
}

const selectors = createSelector(
  (state, props) => selectCampaign(state, props.campaignId),
  (state, props) => selectLink(state, props.linkId),
  (state, props) => selectLinkUrls(state, props.campaignId, props.linkId),
  (state, _) => selectChannelsByAccount(state, selectCurrentAccountId(state)),
  (campaign, link, linkUrls, channels) => ({
    campaign,
    link,
    linkUrls,
    channels: campaign?.type === 'channels'
      ? _.filter(channels, c => _.includes(_.map(campaign?.channels, 'channelId'), c._id))
      : channels,
  })
);

const withConnect = connect(selectors, actions);

// ======================
// COMPONENT
// ====================== 
class LinkUrlModal extends React.Component {
  _inputRef = null
  _onInputRef = n => this._inputRef = n

  componentDidMount() {
    this.props.fetchData(this.props.campaignId, this.props.linkId);
  }

  onCopyAll = () => {
    this._inputRef.value = this.props.channels
      |> _.map(#, v => `${v.serviceName}\t${this.props.linkUrls[v._id]}\r\n`)
      |> _.join(#, '')
    this._inputRef?.select();
    document.execCommand('copy');
  }

  render() {
    let { campaign, link, linkUrls, channels } = this.props;
    return (
      <ModalVertical size="l" className="link-url">
        <textarea ref={this._onInputRef} style={{ width: 0, height: 0, opacity: 0, border: 'none'}} wrap="soft" />
        <ModalHeader>
          <ModalTitle>{campaign?.name}</ModalTitle>
          <ModalSubtitle>Get Short Links for Each Channel</ModalSubtitle>
          <div className="link-info">
            <div className="link-name">{link?.name}</div>
            <div className="link-url">{link?.url}</div>
          </div>
          <ButtonList>
            <SmallButton color="sub" onClick={this.onCopyAll}><CopyIcon size="s" /> Copy All</SmallButton>
            <SmallButton color="sub"><ExcelIcon size="s" />Export to CSV</SmallButton>
          </ButtonList>
        </ModalHeader>
        <ModalContent>
          <Scrollbars>
            <div className="channel-url-list">
              {_.map(channels, channel => (
                <div key={channel._id} className="url-item">
                  <ChannelCard channel={channel} />
                  <div>
                    <CopyInput 
                      size="s" 
                      color="light"
                      value={linkUrls?.[channel._id]} />
                  </div>
                </div>
              ))}
            </div>
          </Scrollbars>
        </ModalContent>
        <ModalActions>
          <Button onClick={this.props.onClose}>Done</Button>
        </ModalActions>
      </ModalVertical>);
  }
};
export default LinkUrlModal
  |> withConnect
